import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { BoxList } from 'modules/core/components/BoxList'
import PanesHeader from 'modules/core/components/PanesHeader'

import type { Automation } from 'modules/automations/store/models/Automation'

import { AutomationListItem } from '../Item'

interface Props {
  automations: Automation[]
  description: string
  title: string
}

export function AutomationsGroup({ automations, description, title }: Props) {
  if (!automations.length) return null

  return (
    <Box gap="s24">
      <PanesHeader
        description={description}
        line={false}
        separation={false}
        size="small"
        title={title}
      />
      <BoxList>
        {automations.map((automation) => (
          <AutomationListItem key={automation.attributes.id} automation={automation} />
        ))}
      </BoxList>
    </Box>
  )
}
